'use client';

import { FC, useEffect } from 'react';

import { getUserGroupId } from 'src/general/components/Analytics/Analytics.helpers';
import { carmaAsciiInConsole } from 'src/general/helpers/carmaAscii';
import { pushToDataLayer } from 'src/utils/pushToDataLayer';

export const WebsiteGlobals: FC = () => {
  useEffect(() => {
    carmaAsciiInConsole();

    const userGroup = getUserGroupId();

    pushToDataLayer({
      event: 'app_init',
      userGroup,
    });
  }, []);

  return null;
};
